import Vue from 'vue';
import AppEditor from '~/components/AppEditor';
export default (editor, opts = {}) => {
    const commands = editor.Commands;
    const modal = editor.Modal;
    const htmlCodeViewer = editor.CodeManager.getViewer('CodeMirror').clone();
    const cssCodeViewer = editor.CodeManager.getViewer('CodeMirror').clone();
    let container = document.createElement('div');
    container.setAttribute('id','vue-app');

    htmlCodeViewer.set({
        codeName: 'htmlmixed',
        readOnly: 0,
        theme: 'hopscotch',
        autoBeautify: true,
        autoCloseTags: true,
        autoCloseBrackets: true,
        lineWrapping: true,
        styleActiveLine: true,
        smartIndent: true,
        indentWithTabs: true
    });

    cssCodeViewer.set({
        codeName: 'css',
        readOnly: 0,
        theme: 'hopscotch',
        autoBeautify: true,
        autoCloseTags: true,
        autoCloseBrackets: true,
        lineWrapping: true,
        styleActiveLine: true,
        smartIndent: true,
        indentWithTabs: true
    });
    
    commands.add('edit-code', {
        run:async function (editor, sender, params) {
            sender && sender.set('active', 0);
            modal.setTitle('Edit code');
            modal.setContent('');
            modal.setContent(container);
            modal.open();
            new Vue({
                ...AppEditor,
                element:"ModalEditorCode",
                editor,
                payload:{
                    htmlCodeViewer,
                    cssCodeViewer
                }
            }).$mount('#vue-app');
            
        }
    });
};
  